export default __webpack_public_path__ + "static/media/logo_apa.ba4920c4.webp";